export interface FaqItem {
  q: string;
  a: string;
}

/**
 * Conversational Q&A block. Rendered server-side with semantic markup so
 * answer engines (Gemini, ChatGPT Search, Perplexity) can extract each
 * question/answer pair directly from the HTML.
 */
export function FaqBlock({ items }: { items: FaqItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className="space-y-6" data-aeo="faq">
      {items.map((faq, i) => (
        <div key={i} data-aeo="faq-item">
          <h3 className="font-semibold text-foreground mb-1" data-aeo="question">
            {faq.q}
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed" data-aeo="answer">
            {faq.a}
          </p>
        </div>
      ))}
    </div>
  );
}
